import { ChangeEvent } from 'react';
import api from './api';

interface typeList {
  id: string;
  url: string;
  origin: string;
  file?: File;
  label?: string;
  ordem?: number | null;
}

/**
 * Ordena pela posicao gravada (`ordem`).
 *
 * Arquivo salvo antes deste campo existir vem com `ordem: null` — para esses o
 * criterio e `createdAt`, e NAO `updatedAt`: `updatedAt` e reescrito toda vez que
 * a legenda muda, entao ordenar por ele fazia a imagem "pular" de lugar no
 * relatorio a cada edicao. `createdAt` nao muda mais depois do upload.
 *
 * Os antigos (sem ordem) vao para o fim, preservando entre si a ordem de criacao.
 */
export const compararOrdemArquivo = (a: any, b: any): number => {
  const oa = a ? a.ordem : null;
  const ob = b ? b.ordem : null;
  const temA = oa !== null && oa !== undefined;
  const temB = ob !== null && ob !== undefined;
  if (temA && temB) return Number(oa) - Number(ob);
  if (temA) return -1;
  if (temB) return 1;
  return ((a && a.createdAt) || '').localeCompare((b && b.createdAt) || '');
};

export const ordenarArquivos = <T extends { ordem?: number | null; createdAt?: string }>(
  lista: T[]
): T[] => [...lista].sort(compararOrdemArquivo);

export const getAllFileByQuery = async (osId: string, tipo: string) => {
  const files = await api.get(`/files?os=${osId}&etapa=${tipo}`);
  const photos = await api.get(`/photos?os=${osId}&etapa=${tipo}`);
  return ordenarArquivos(files.data.concat(photos.data));
};

export const getAllFileByOs = (osId: string) => {
  return api.get(`/files?os=${osId}`);
};

export const deleteFile = (id: string) => {
  return api.delete(`/files/${id}`);
};

export const getFileById = (id: string) => {
  return api.get(`/files/${id}`);
};

export const updateFile = (
  id: string,
  nome: string,
  osId: string,
  etapa: string,
  label?: string,
  ordem?: number | null
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`/files/${id}`, { nome: nome, os: osId, etapa: etapa, label, ordem })
      .then((result) => {
        resolve(result);
      })
      // Sem este catch a Promise ficava pendente para sempre em caso de falha, e
      // a tela travava sem dizer nada.
      .catch((error) => {
        reject(error);
      });
  });
};

export const createFile = (
  nome: string,
  osId: string,
  etapa: string,
  file: File,
  label?: string,
  ordem?: number | null
) => {
  return new Promise((resolve, reject) => {
    api
      .post(`/files/`, { nome: nome, os: osId, etapa: etapa, label, ordem })
      .then((res: any) => {
        const formData: FormData = new FormData();

        formData.append('file', file, file.name);
        api.post(`/files/upload/${res.data.id}`, formData)
          .then((resImg) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadFile = (
  nome: string,
  osId: string,
  etapa: string,
  file: File,
  label?: string
) => {
  return new Promise((resolve, reject) => {
    api
      .post(`/photos/`, { nome: nome, os: osId, etapa: etapa, label })
      .then((res: any) => {
        const formData: FormData = new FormData();
        formData.append('img', file, `${res.data.id}.png`);

        api.post(`/photos/upload/${res.data.id}`, formData).then((resImg) => {
          resolve(res);
        });
      });
  });
};

export const handleImage = async (
  { target }: ChangeEvent<HTMLInputElement>,
  data: typeList[]
) => {
  if (target.files) {
    const dataFiles = Array.from(target.files);

    const newData = dataFiles.map((file: File) => {
      return {
        id: `${file.lastModified}-${file.name}`,
        url: URL.createObjectURL(file),
        origin: 'local',
        file: file,
        label: '',
      };
    });

    return [...data, ...newData];
  }
};
